import React from 'react';
import { useFetch } from '../../hooks/useFetch';

const WorkoutItem = (props) => {
  return(
    <div className='flex justify-between px-4 xl:px-8 2xl:px-10'>{props.text}: <span className='font-bold'>{props.value}</span></div>
  )
}

// The API returns the FitBit daily summary: { summary: { caloriesOut, steps, distances: [...] }, ... }
const parseStats = (data) => {
  const summary = data?.summary
  if (!summary) return null

  let distance = 0
  for (const element of summary.distances ?? []) {
    distance = distance + element.distance
  }

  return {
    calories: '💥' + summary.caloriesOut + '💥',
    steps: '👟' + summary.steps + '👟',
    distance: '📏' + distance.toFixed(2) + '📏'
  }
}

export const Workout = (props) => {
  const { data, loading, error } = useFetch(props.targetUrl, { cache: false });
  const stats = parseStats(data);

  return (
    <div className='text-stone-800 dark:text-white xl:text-3xl 2xl:text-4xl text-center'>
        {loading && <div className='text-xl font-bold text-center'>Loading...</div>}
        {error && <div className='text-xl font-bold text-center'>Error: {error.message}</div>}
        {stats &&
          <div>
            <WorkoutItem text={'Calories burned'} value={stats.calories} />
            <WorkoutItem text={'Step counter'} value={stats.steps} />
            <WorkoutItem text={'Distance'} value={stats.distance} />
          </div>}
    </div>
  )
}
